import React, { useContext, createContext, ReactNode, useState } from "react";
import { ITheme, TBrowserAppType } from "../interface";
import { themes } from "../constant";
import { browserAppType } from "../app/utils";

const defaultTheme: ITheme = themes.dark;

let defaultValue = {
  theme: defaultTheme,
  oppositeTheme: themes.light,
  browserType: "chrome" as TBrowserAppType,
  toggleTheme: (theme: ITheme) => undefined as any,
};
const ThemeContext = createContext(defaultValue);

const ThemeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const browserType = browserAppType();
  const [theme, setTheme] = useState(defaultTheme);
  const [oppositeTheme, setOppositeTheme] = useState(themes.light);
  const toggleTheme = (loadTheme: ITheme) => {
    setTheme(loadTheme);
    setOppositeTheme(loadTheme.name === "dark" ? themes.light : themes.dark);
  };
  return (
    <ThemeContext.Provider
      value={{ theme, browserType, oppositeTheme, toggleTheme }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;

export const useTheme = () => useContext(ThemeContext);
